module.exports = __webpack_public_path__ + "media/src/assets/Images/UploadPhoto-01934ff39a06cf535d1959a2813a49d4.svg";